import type { ComponentProps, ComponentType } from 'react';

import { clsxm } from '@vs-shop/utils';
import { type VariantProps, cva } from 'class-variance-authority';

const alertVariants = cva('text-foreground-muted flex flex-1', {
  variants: {
    variant: {
      success: 'bg-success/25',
      destructive: 'bg-destructive/25',
      warning: 'bg-warning-intense/25',
      info: 'bg-info/25',
      neutral: 'bg-background-inverted/25',
    },
  },
  defaultVariants: {
    variant: 'neutral',
  },
});

const alertAccentVariants = cva('flex w-2 flex-col', {
  variants: {
    variant: {
      success: 'bg-success',
      destructive: 'bg-destructive',
      warning: 'bg-warning-intense',
      info: 'bg-info',
      neutral: 'bg-background-inverted',
    },
  },
  defaultVariants: {
    variant: 'neutral',
  },
});

export type AlertProps = ComponentProps<'div'> &
  VariantProps<typeof alertVariants> & {
    icon?: ComponentType<ComponentProps<'svg'>>;
  };

export function Alert({ variant, icon: Icon, children, className, ...props }: AlertProps) {
  return (
    <div data-slot="alert" className={clsxm(alertVariants({ variant }), className)} {...props}>
      <div data-slot="alert-accent" className={alertAccentVariants({ variant })} />
      <div className="flex gap-2 p-2">
        {Icon && <Icon className="h-5 w-5 shrink-0" />}
        <span className="text-sm/5">{children}</span>
      </div>
    </div>
  );
}

export { alertAccentVariants, alertVariants };
